<template>
    <v-container class="inner-main pt-2 mb-10">
        <v-row class="mx-0">
            <h2>{{ $t('global.menu.backoffice.manageUsers') }}</h2>
        </v-row>
        <v-row class="mb-3">
            <v-data-table-server v-model:items-per-page="itemsPerPage" :items-per-page-options="pageOptions"
                density="compact" :headers="headers" :items="serverItems" :items-length="totalItems" :loading="loading"
                :search="search" item-value="name" @update:options="loadItems" height="60vh" fixed-header
                :update:sortBy="updateSortBy" :mobile="['xs', 'sm', 'md'].includes($globalState.screenWidth)"
                class="shop-list-table">
                <template v-slot:top>
                    <v-row>
                        <v-col>
                            <!-- TODO BACKEND SEARCH FUNCTION PAGINATION -->
                            <v-text-field v-model="search" :disabled="false"
                                :placeholder="$t('main.search.placeholder')" variant="outlined" hide-details="true"
                                density="compact" class="pb-2 py-0 bg-white" height="32px">
                                <template v-slot:append-inner>
                                    <v-icon icon="mdi-magnify"></v-icon>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col>
                            <!-- <CustomFilterMenu :title="'status'" :items="['disabled','published','pending','created']" v-model="filter" :multiple="true"></CustomFilterMenu> -->
                            <!-- {{ filter }} -->
                        </v-col>
                    </v-row>
                </template>
                <!-- <template v-slot:[`item.info`]="props">
                    <v-tooltip>
                        <template v-slot:activator="{ props }">
                            <v-icon v-bind="props">mdi-information-variant</v-icon>
                        </template>
                        <span>registered: {{ $formatDate(props.item.registered) }}</span><br>
                        <span>last Login: {{ $formatDate(props.item.lastLogin || null) }}</span>
                    </v-tooltip>
                </template> -->
                <!-- <template v-slot:[`item.registered`]="{ value }">
                    {{ $formatDateWithoutDay(value) }}
                </template>
                <template v-slot:[`item.lastLogin`]="{ value }">
                    {{ $formatDateWithoutDay(value) }}
                </template> -->

                <template v-slot:[`item.controls`]="props">
                    <!-- <v-btn  size="x-small" class="mx-2" flat dark x-small color="transparent">
                        <v-icon color="error" icon="mdi-cancel">

                        </v-icon>
                    </v-btn>
                    <v-btn  color="error" class="mx-2" variant="flat" size="32">
                        <v-icon icon="mdi-trash-can-outline">

                        </v-icon>
                    </v-btn> -->
                    <v-menu class="actions-menu">
                        <template v-slot:activator="{ props }">
                            <v-btn v-bind="props" size="x-small" class="mx-2" flat dark x-small color="transparent"
                                icon="mdi-chevron-down">
                            </v-btn>
                        </template>
                        <v-list :density="'compact'" lines="false">

                            <v-list-item density="compact" v-if="props.item.status === 'DEACTIVATED'">
                                <v-list-item-title><v-icon size="x-small"
                                        color="success">mdi-check-circle-outline</v-icon>
                                    {{ $t('entity.action.activate') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item density="compact" v-else>
                                <v-list-item-title><v-icon size="x-small" color="error">mdi-cancel</v-icon>
                                    {{ $t('entity.action.deactivate') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item density="compact" @click="() => removeUser()">
                                <v-list-item-title><v-icon size="x-small" color="error">mdi-trash-can-outline</v-icon>
                                    {{ $t('entity.action.delete') }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>

                </template>

            </v-data-table-server>
        </v-row>
        <CustomConfirmDeletionDialog v-model="showDeleteDialog" :confirm-deletion="deleteUser"
            v-model:data="removedLabelCategory" :title="'Delete Label Category'"
            :question="'Are you sure you want to Delete ?'">
        </CustomConfirmDeletionDialog>
    </v-container>
</template>

<script>
import { ref, inject, getCurrentInstance, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import CustomConfirmDeletionDialog from './modals/CustomConfirmDeletionDialog.vue';

export default {
    components: {
        CustomConfirmDeletionDialog
    },
    setup() {

        const { proxy } = getCurrentInstance();
        const router = useRouter();
        const removedUser = ref(null);
        const showDeleteDialog = ref(false);
        const selectedLanguage = localStorage.getItem('selectedLanguage');
        const { t, locale } = useI18n();
        const softToken = localStorage.getItem("softToken");
        const hardToken = localStorage.getItem("hardToken");
        const username = localStorage.getItem("username");

        const updateSortBy = (newSort) => {
            proxy.sortBy = newSort;
        }

        const removeUser = async (item) => {

            removedUser.value = item;
            showDeleteDialog.value = true;
            console.log(removedUser.value);
        }

        const deleteUser = async (item) => {
            try {
                const response = await proxy.$axios.delete(`/backoffice/users/${item.id}`, {
                    headers: {
                        'X-Auth-HARDTOKEN': hardToken,
                        'X-Auth-SOFTTOKEN': softToken,
                        'X-Auth-USER': username
                    },
                });

                if (response.data.status == "OK") {
                    showDeleteDialog.value = false;
                    proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage, sortBy: proxy.sortBy });
                }
            } catch (error) {
                console.error("Error fetching search results:", error);
            }
        }

        return {
            deleteUser,
            selectedLanguage,
            updateSortBy,
            removeUser,
            showDeleteDialog
        };
    },

    watch: {

    },

    data: () => ({
        itemsPerPage: 50,
        sortBy: [],
        pageOptions: [
            { value: 50, title: '50' },
            { value: 100, title: '100' },
            { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
        ],
        headers: [
            { title: 'Username', key: 'username', align: 'start', maxWidth: "200px" },
            { title: 'Email', key: 'email', align: 'start' },
            { title: 'Roles', key: 'roles', align: 'start' },
            { title: 'Status', key: 'status', align: 'start' },
            { title: 'Last Login', value: "lastLogin", align: 'start', sortable: true },
            { title: 'Registered', value: "registered", align: 'start', sortable: true },
            { title: 'Actions', value: "controls", align: 'end', sortable: false },
        ],
        search: '',
        serverItems: [],
        loading: true,
        totalItems: 0,
    }),

    computed: {
    },

    mounted() {
    },

    methods: {
        loadItems({ page, itemsPerPage, sortBy }) {
            this.loading = true
            console.log(this.search)
            const hardToken = localStorage.getItem("hardToken");
            const username = localStorage.getItem("username");
            this.$axios.get(this.search.length >= 1 ? "/backoffice/users/query" : "/backoffice/users", {
                headers: {
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-USER': username
                },
                params: {
                    sortColumn: sortBy[0]?.key == 'registered' ? "created" : sortBy[0]?.key,
                    sortDirection: sortBy[0]?.order.toUpperCase(),
                    ...(this.search.length >= 1 ? { search: this.search, resultsPerPage: itemsPerPage, page: page - 1 } : { page: page - 1, resultsPerPage: itemsPerPage })
                }
            })
                .then(this.itemsFetched)
                .catch(error => {
                    console.error("Error fetching user data:", error);
                    // You can handle specific error codes here, for example, a 401 Unauthorized
                    if (error.response && error.response.status === 401 || error.response.status === 403) {
                        // Handle token expiration or unauthorized error
                        console.log("Session expired or unauthorized. Please log in again.");
                        // Optionally log the user out or redirect to login page
                    }
                });
        },
        itemsFetched(response) {
            console.log(response)
            this.serverItems = response.data.data;
            this.totalItems = response.data.totalElements
            this.loading = false
        }
    },
}
</script>

<style scoped>
.inner-main {
    margin-left: auto;
    margin-right: auto;
    max-width: 1170px;
    margin-top: 40px;
}
</style>

<style></style>

<style></style>